import * as React from 'react';
import styled from 'styled-components';
import { Row } from '../layout/Row';
import { Avatar } from '../shared/Avatar';

interface IProps {
  entityName: string;
  entityImage: string;
  secondaryTextMajor: string;
  secondaryTextMinor: string;
  style?: React.CSSProperties;
}

const SectionHeader = (props: IProps): React.ReactElement => {
  return (
    <Row style={{ marginLeft: '10px' }}>
      <LeftSide>
        <Avatar size='medium' src={props.entityImage} />
        <InfoContainer>
          <PrimaryText>{props.entityName}</PrimaryText>
          <SecondaryContainer>
            <SecondaryText>{props.secondaryTextMajor}</SecondaryText>
            <SecondaryText>{props.secondaryTextMinor}</SecondaryText>
          </SecondaryContainer>
        </InfoContainer>
      </LeftSide>
      <RightSide></RightSide>
    </Row>
  );
};

export { SectionHeader };

const InfoContainer = styled.div`
  margin-left: 5px;
  display: flex;
  flex-direction: row;
  padding: 0px 10px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const PrimaryText = styled.h6`
  @media (min-width: 991px) {
    border-right: 0.5px solid var(--color-secondary-text);
  }
  padding-right: 10px;
`;

const SecondaryContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SecondaryText = styled.div`
  margin-left: 10px;
  color: var(--color-secondary-text);
  @media (max-width: 990px) {
    margin-left: 0px;
  }
`;

const LeftSide = styled.div`
  flex: 4;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0;
  justify-content: flex-end;
`;
